"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TierFeatures = void 0;
var _react = _interopRequireDefault(require("react"));
var _CheckMark = _interopRequireDefault(require("../../CheckMark"));
var _common = require("../../common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TierFeatures = exports.TierFeatures = function TierFeatures(props) {
  var features = props.features,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? "light" : _props$theme,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  var isLightBackground = theme === "light";
  var renderFeature = function renderFeature(feature, featureIdx) {
    var _feature$description;
    var checkStyle = {
      width: 16,
      color: isLightBackground ? "black" : "white"
    };
    return /*#__PURE__*/_react["default"].createElement(_CheckMark["default"], _extends({}, checkStyle, {
      key: featureIdx
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "ml-4"
    }, (_feature$description = feature.description) === null || _feature$description === void 0 ? void 0 : _feature$description.map(function (_ref, descriptionIdx) {
      var text = _ref.text,
        style = _ref.style,
        hoverProps = _ref.hoverProps;
      return Boolean(hoverProps === null || hoverProps === void 0 ? void 0 : hoverProps.text) ? /*#__PURE__*/_react["default"].createElement(_common.Tooltip, {
        key: "feature-description-".concat(descriptionIdx),
        content: hoverProps === null || hoverProps === void 0 ? void 0 : hoverProps.text,
        direction: hoverProps === null || hoverProps === void 0 ? void 0 : hoverProps.direction,
        styleOverrides: {
          tip: {
            backgroundColor: "#1F1F1F"
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-base ml-1 ".concat(isMobile ? "font-normal" : "font-bold", " ").concat(isLightBackground ? "text-black" : "text-white"),
        style: _objectSpread({
          lineHeight: 1.18
        }, style || {})
      }, text)) : /*#__PURE__*/_react["default"].createElement("span", {
        key: "feature-description-".concat(descriptionIdx),
        className: "text-base ml-1 ".concat(isMobile ? "font-normal" : "font-bold", " ").concat(isLightBackground ? "text-black" : "text-white"),
        style: _objectSpread({
          lineHeight: 1.18
        }, style || {})
      }, text);
    })));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col ".concat(isMobile ? "gap-y-2 pt-4" : "gap-y-4 pt-6")
  }, features.map(renderFeature));
};